<template>
    <div class="conteudoplataforma">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'ConteudoInterativo'
}
</script>

<style>
.conteudoplataforma {
    /*grid-area: okara;*/
    position: relative;
    width: 100%;
    background-color: #e9e9e9;
    overflow: hidden;
}
</style>